<div class="vz-toolbar">
  <img ngSrc="verizon-logo.svg" alt="Verizon" class="vz-logo" width="223" height="50" priority />
  <span class="vz-title">Network Planner</span>
  <span class="vz-version" aria-label="Application version">v{{ appVersion }}</span>
  <nav class="vz-nav" aria-label="Main navigation">
    <a routerLink="/" routerLinkActive="active"
       [routerLinkActiveOptions]="{exact: true}">Home</a>
    <a routerLink="/vsub" routerLinkActive="active">Coverage Analysis</a>
  </nav>
  <button
    #workerTrigger
    type="button"
    class="vz-toolbar-btn vz-toolbar-btn--worker"
    [attr.aria-label]="'Open GPU/CPU settings (' + executionTargetLabel() + ')'"
    (click)="openWorkerDialog()">
    <span class="vz-toolbar-btn__icon" aria-hidden="true">
      <svg class="vz-toolbar-btn__icon-svg" viewBox="0 0 24 24" focusable="false" aria-hidden="true">
        <rect x="6" y="6" width="12" height="12" rx="2.2" fill="none" stroke="currentColor" stroke-width="1.8"/>
        <rect x="9.3" y="9.3" width="5.4" height="5.4" rx="0.9" fill="currentColor"/>
        <path d="M9 3.8V6M12 3.8V6M15 3.8V6M9 18V20.2M12 18V20.2M15 18V20.2M3.8 9H6M3.8 12H6M3.8 15H6M18 9H20.2M18 12H20.2M18 15H20.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
      </svg>
    </span>
    <span>{{ executionTargetLabel() }}</span>
  </button>
  <button
    #settingsTrigger
    type="button"
    class="vz-toolbar-btn"
    aria-label="Open application settings"
    (click)="openSettings()">
    <span class="vz-toolbar-btn__icon" aria-hidden="true">⚙</span>
    <span>Settings</span>
  </button>
</div>
<router-outlet />
<app-gpu-worker-dialog [open]="workerDialogOpen()" (closed)="closeWorkerDialog()" />
<app-app-settings-dialog [open]="settingsOpen()" (closed)="closeSettings()" />
